/**
 * Canonical activation funnel events (web + mobile).
 * Successful actions only; repeats are allowed — PostHog funnels use first occurrence per user.
 */

/** @typedef {'web' | 'mobile'} ActivationPlatform */

/** @typedef {'intervals' | 'strava' | 'zwift'} IntegrationProvider */

/** @typedef {'template' | 'ai' | 'manual'} PlanGenerationSource */

/** @typedef {'zwo' | 'fit' | 'erg' | 'zip'} WorkoutExportFormat */

export const ACTIVATION_EVENTS = Object.freeze({
  PLAN_GENERATED: 'plan_generated',
  FUELING_RECOMMENDATION_VIEWED: 'fueling_recommendation_viewed',
  WORKOUT_EXPORTED: 'workout_exported',
  INTEGRATION_CONNECTED: 'integration_connected',
  INTEGRATION_SYNC_SUCCEEDED: 'integration_sync_succeeded',
  RIDE_OUTCOME_SUBMITTED: 'ride_outcome_submitted',
});

export const ACTIVATION_EVENT_PROPS = Object.freeze({
  PLATFORM: 'platform',
  SOURCE: 'source',
  PROVIDER: 'provider',
  FORMAT: 'format',
});

/**
 * Legacy event names retained for one release (dashboard migration).
 * Aliases are platform-specific — dual-emit only where the name existed pre-PR:
 * web: plan_created, export_workout; mobile: first_plan_generated,
 * first_fueling_recommendation_viewed, sync_connected (no mobile export_workout).
 */
export const ACTIVATION_LEGACY_EVENTS = Object.freeze({
  PLAN_CREATED: 'plan_created',
  EXPORT_WORKOUT: 'export_workout',
  FIRST_PLAN_GENERATED: 'first_plan_generated',
  FIRST_FUELING_RECOMMENDATION_VIEWED: 'first_fueling_recommendation_viewed',
  SYNC_CONNECTED: 'sync_connected',
});
